(function () {
	if (typeof window.CustomEvent === "function") {
		// If not IE
		return false;
	}

	function CustomEvent(event, params) {
		const parameters = params || { bubbles: false, cancelable: false, detail: null };
		const evt = document.createEvent('CustomEvent');
		evt.initCustomEvent(event, parameters.bubbles, parameters.cancelable, parameters.detail);
		return evt;
	}

	CustomEvent.prototype = window.Event.prototype;

	window.CustomEvent = CustomEvent;
})();
